<template>
    <v-card :loading="loading" min-height="500" flat mx-2>
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-container class="px-10" fluid v-if="!loading">
            <form autocomplete="off">
                <v-row>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Detalii deviz</v-card-title>
                            <v-card-text>
                                <v-autocomplete
                                    :items="mechanics"
                                    item-value="id"
                                    item-text="name"
                                    v-model="form.mechanic_id"
                                    :error-messages="errorMessages('mechanic_id')"
                                    :class="{ 'error--text': hasErrors('mechanic_id') }"
                                    class="primary--text"
                                    name="mechanic_id"
                                    label="Responsabil mecanic"
                                    data-vv-as="Responsabil mecanic"
                                    data-vv-name="mechanic_id"
                                />
                                <v-combobox
                                    :items="phoneSuggestions"
                                    v-model="form.data.phone"
                                    :search-input.sync="form.data.phone"
                                    :error-messages="errorMessages('data.phone')"
                                    :class="{ 'error--text': hasErrors('data.phone') }"
                                    class="primary--text"
                                    name="data.phone"
                                    label="Telefon client"
                                    data-vv-as="Telefon client"
                                    data-vv-name="data.phone"
                                    :autocomplete="`autocomplete_off_${strRandom(10)}`"
                                />
                                <v-combobox
                                    :items="emailSuggestions"
                                    v-model="form.data.email"
                                    :search-input.sync="form.data.email"
                                    :error-messages="errorMessages('data.email')"
                                    :class="{ 'error--text': hasErrors('data.email') }"
                                    class="primary--text"
                                    name="data.email"
                                    label="E-mail client"
                                    data-vv-as="E-mail client"
                                    data-vv-name="data.email"
                                    :autocomplete="`autocomplete_off_${strRandom(10)}`"
                                />
                                <v-textarea
                                    v-if="showMore"
                                    v-model="form.data.remarks"
                                    :error-messages="errorMessages('data.remarks')"
                                    :class="{ 'error--text': hasErrors('data.remarks') }"
                                    class="primary--text"
                                    name="data.remarks"
                                    label="Observatii interne"
                                    data-vv-as="Observatii interne"
                                    data-vv-name="data.remarks"
                                />
                                <v-textarea
                                    v-if="showMore"
                                    v-model="form.data.client_remarks"
                                    :error-messages="errorMessages('data.client_remarks')"
                                    :class="{ 'error--text': hasErrors('data.client_remarks') }"
                                    class="primary--text"
                                    name="data.client_remarks"
                                    label="Observatii client"
                                    data-vv-as="Observatii client"
                                    data-vv-name="data.client_remarks"
                                />
                                <v-text-field
                                    v-model="form.amount_advance"
                                    :error-messages="errorMessages('amount_advance')"
                                    :class="{ 'error--text': hasErrors('amount_advance') }"
                                    class="primary--text"
                                    name="amount_advance"
                                    label="Avans client"
                                    data-vv-as="Avans client"
                                    data-vv-name="amount_advance"
                                    type="number"
                                />
                                <v-text-field
                                    v-if="showMore"
                                    v-model="form.data.vehicle_mileage"
                                    :error-messages="errorMessages('data.vehicle_mileage')"
                                    :class="{ 'error--text': hasErrors('data.vehicle_mileage') }"
                                    class="primary--text"
                                    name="data.vehicle_mileage"
                                    label="Rulaj autovehicul"
                                    data-vv-as="Rulaj autovehicul"
                                    data-vv-name="data.vehicle_mileage"
                                    type="number"
                                />
                                <v-text-field
                                    v-model="form.data.execution"
                                    :error-messages="errorMessages('data.execution')"
                                    :class="{ 'error--text': hasErrors('data.execution') }"
                                    class="primary--text"
                                    name="data.execution"
                                    label="Termen de executie"
                                    data-vv-as="Termen de executie"
                                    data-vv-name="data.execution"
                                />
                                <v-date-field
                                    v-model="form.next_inspection"
                                    :error-messages="errorMessages('next_inspection')"
                                    :class="{ 'error--text': hasErrors('next_inspection') }"
                                    class="primary--text"
                                    name="next_inspection"
                                    label="Urmatoarea inspectie"
                                    data-vv-as="Urmatoarea inspectie"
                                    data-vv-name="next_inspection"
                                    inputmask-placeholder="99-99-9999"
                                    placeholder="zz-ll-aaaa"
                                />
                                <v-text-field
                                    v-if="showMore"
                                    v-model="form.data.rate"
                                    :error-messages="errorMessages('data.rate')"
                                    :class="{ 'error--text': hasErrors('data.rate') }"
                                    class="primary--text"
                                    name="data.rate"
                                    label="Tarif lei/ora"
                                    data-vv-as="Tarif lei/ora"
                                    data-vv-name="data.rate"
                                />
                                <v-btn color="primary" block @click="showMore = !showMore">{{ showMore ? 'Mai putin' : 'Mai mult'}}</v-btn>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Detalii client</v-card-title>
                            <v-card-text>
                                <customer-modal
                                    v-model="form.customer_id"
                                    :field-errors="errorMessages('customer_id')"
                                    :initial-items="[form.customer]"
                                    @change="(customer) => form.customer = customer"
                                    :expandeable="true"
                                    show-summary
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Detalii vehicul</v-card-title>
                            <v-card-text>
                                <vehicle-modal
                                    v-model="form.vehicle_id"
                                    :field-errors="errorMessages('vehicle_id')"
                                    :initial-items="[form.vehicle]"
                                    :customer-id="form.customer_id"
                                    :autocomplete="true"
                                    :expandeable="true"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3">
                        <v-card elevation="2">
                            <v-card-title>Actiuni deviz</v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <template v-if="!_.isNil(form.id)">
                                                <v-subheader>Ofertare si facturare</v-subheader>
                                                <v-btn
                                                    v-if="!_.isNil(form.id)"
                                                    block
                                                    color="info"
                                                    class="my-2"
                                                    @click="downloadOffer"
                                                >
                                                    Generare Oferta
                                                </v-btn>
                                                <v-btn
                                                    v-if="!_.isNil(form.id)"
                                                    :disabled="_.isNil(form.deviz_number) && !isDocumentOwner"
                                                    block
                                                    :color="!_.isNil(form.deviz_number) ? 'warning' : 'primary'"
                                                    class="my-2"
                                                    @click="downloadDeviz"
                                                >
                                                    {{ !_.isNil(form.deviz_number) ? `Deviz ${form.deviz_number}` : `Generare deviz` }}
                                                </v-btn>

                                                <v-divider class="my-4"></v-divider>
                                            </template>


                                            <v-subheader>Schimbare stare</v-subheader>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && canEdit && form.status !== 'FINALIZED'"
                                                :disabled="!isDocumentOwner"
                                                block
                                                color="warning"
                                                class="my-2"
                                                @click="setStatus('FINALIZED')"
                                            >
                                                Status: Finalizat
                                            </v-btn>

                                            <v-btn
                                                v-if="!_.isNil(form.id) && canEdit"
                                                :disabled="!isDocumentOwner"
                                                block
                                                color="error"
                                                class="my-2"
                                                @click="setStatus('CANCELED')"
                                            >
                                                Status: Anulat
                                            </v-btn>

                                            <v-subheader>Actiuni</v-subheader>
                                            <v-btn
                                                v-if="canEdit"
                                                :loading="form.busy"
                                                :disabled="errors.any() || form.busy"
                                                block
                                                color="success"
                                                class="my-2"
                                                @click="submit()"
                                            >
                                                <v-icon left>
                                                    save
                                                </v-icon>
                                                Salveaza
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card elevation="2">
                            <v-card-title>Produse si servicii</v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead class="offer-thead">
                                        <tr>
                                            <th class="text-left" width="150">
                                                Tip
                                            </th>
                                            <th class="text-left">
                                                Denumire
                                            </th>
                                            <th class="text-left" width="200">
                                                Cod Produs
                                            </th>
                                            <th class="text-left" width="50">
                                                Cantitate
                                            </th>
                                            <th class="text-left" width="50">
                                                UM
                                            </th>
                                            <th class="text-left" width="100">
                                                Pret Unitar
                                            </th>
                                            <th class="text-right" width="50">
                                                <v-btn :disabled="!canEdit" color="success" x-small @click="addProduct(undefined)">Adaugare</v-btn>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody class="offer-tbody">
                                            <tr>
                                                <td colspan="7"><h4>Produse</h4></td>
                                            </tr>
                                            <template v-for="(product, index) in form.products">
                                                <v-offer-row
                                                    v-if="product.type === 'PRODUCT'"
                                                    :key="`product-${index}`"
                                                    :value="product"
                                                    :index="index"
                                                    :has-errors="hasErrors"
                                                    :error-messages="errorMessages"
                                                    :can-edit="canEdit"
                                                    @input="(val) => form.products[index] = val"
                                                    @delete="deleteProduct(index)"
                                                />
                                            </template>
                                            <tr>
                                                <td colspan="7"><h4>Servicii</h4></td>
                                            </tr>
                                            <template v-for="(product, index) in form.products">
                                                <v-offer-row
                                                    v-if="product.type !== 'PRODUCT'"
                                                    :key="`product-${index}`"
                                                    :value="product"
                                                    :index="index"
                                                    :has-errors="hasErrors"
                                                    :error-messages="errorMessages"
                                                    :can-edit="canEdit"
                                                    @input="(val) => form.products[index] = val"
                                                    @delete="deleteProduct(index)"
                                                />
                                            </template>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td colspan="3">Total</td>
                                            <td>{{ _.sumBy(form.products, (product) => parseFloat(product.quantity)) | number }}</td>
                                            <td></td>
                                            <td>
                                                {{ totalValue | price({currency: 'RON'}) }}
                                            </td>
                                            <td>
                                                <v-btn :disabled="!canEdit" color="success" x-small @click="addProduct(undefined)">Adaugare</v-btn>
                                            </td>
                                        </tr>
                                        </tfoot>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </form>
        </v-container>
    </v-card>
</template>

<script>
    import CustomerModal from 'Components/modal/CustomerModal'
    import VehicleModal from 'Components/modal/VehicleModal'

    import validationError from "Mixins/validation-error";
    import ACL from "Mixins/acl";
    import {Form} from "vform";
    import throttle from 'lodash/throttle'
    import { createNamespacedHelpers } from "vuex";
    const { mapGetters } = createNamespacedHelpers("auth");

    export default {
        mixins: [validationError, ACL],
        components: {
            CustomerModal,
            VehicleModal
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            showMore: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                customer_id: null,
                proforma_no: null,
                deviz_no: null,
                vehicle_id: null,
                document_no: null,
                offer_date: null,
                next_inspection: null,
                status: null,
                amount_advance: 0,
                customer: {
                    summary: {
                        emails: [],
                        phones: [],
                    }
                },
                vehicle: null,
                products: [],
                created_by: null,
                data: {
                    rate: null,
                    contact_person: null,
                    email: null,
                    phone: null,
                    remarks: null,
                    client_remarks: null,
                    vehicle_mileage: null,
                    execution: null
                }
            }),
            mechanics: []
        }),
        computed: {
            ...mapGetters({
                getMe: "getMe"
            }),
            canEdit() {
                if (this._.isNil(this.form.id)) return true
                if (this.hasRole('admin')) return true
                if ((!this._.isNil(this.form.status) && ['CANCELED', 'FINALIZED'].indexOf(this.form.status) >= 0)) return false
                if (!this.isDocumentOwner) return false
                return true
            },
            isDocumentOwner() {
                if (this._.isNil(this.form.id)) return true
                return !this._.isNil(this.form.created_by) && this.getMe?.id === this.form.created_by || this.hasRole('admin')
            },
            emailSuggestions() {
                return Object.values(this.form.customer?.summary?.emails || {})
            },
            phoneSuggestions() {
                return Object.values(this.form.customer?.summary?.phones || {})
            },
            totalValue() {
                return this._.sumBy(this.form.products, (product) => { return parseFloat(product.quantity) * parseFloat(product.unit_price)})
            }
        },
        watch: {
            'form.customer': {
                handler(val) {
                    if(val?.id) {
                        this.form.customer_id = val.id
                    }
                },
                deep: true
            },
            'form.vehicle': {
                handler(val) {
                    if(val?.id) {
                        this.form.vehicle_id = val.id
                    }
                },
                deep: true
            },
            'form.next_inspection': {
                handler (val) {
                    if (val === '' || !this.$moment(val).isValid()) {
                        this.form.next_inspection = null
                    }
                }
            }
        },
        async mounted() {
            await this.loadMechanics()
            if(this.id) {
                await this.loadResource()
            }
            if(this.form.products.length < 1) {
                await this.addInitialProducts()
            }
        },
        methods: {
            async loadMechanics () {
                this.mechanics = await this.$db.Employee
                    .where('hasRoles', 'service')
                    .limit(500)
                    .get()
                    .then(({data}) => data)
            },
            async addInitialProducts () {
                return await this.$db.Product
                    .where('initial', true)
                    .get()
                    .then(({data}) => {
                        data.forEach((elem) => {
                            this.addProduct(false, {
                                id: elem.id,
                                type: elem.type,
                                name: elem.name,
                                product_number: elem.product_number,
                                quantity: 1,
                                measurement: 'ORA',
                                unit_price: 0,
                            })
                        })
                    })
            },
            loadResource: throttle(async function (val) {
                let self = this;
                this.loading = true;

                let data = await this.$db.Offer
                    .include('customer', 'vehicle', 'products')
                    .append('deviz_number')
                    .find(this.id)
                    .then(({data}) => {
                        data.products = data.products.map((product) => {
                            return {
                                id: product.id,
                                type: product.type,
                                name: product.name,
                                product_number: product.product_number,
                                quantity: product.pivot.quantity,
                                measurement: product.pivot.measurement,
                                unit_price: product.pivot.unit_price
                            }
                        })
                        if (!this._.isNil(data.next_inspection)) {
                            data.next_inspection = this.$moment(data.next_inspection).format('DD-MM-YYYY')
                        }
                        return data
                    })
                self.form = new Form(data)
                this.loading = false
            }, 500),
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Offer(Object.assign(self.form, {
                    next_inspection: !this._.isNil(self.form.next_inspection) ? this.$moment(self.form.next_inspection, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
                }));
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        self.form.errors.set({})
                        this.showSuccess();
                        if (this._.isNil(model.id) && response?.id) {
                            self.$nextTick(() => self.$router.push({name: "offers-edit", params: {id: response.id}}));
                        } else {
                            this.loadResource()
                        }
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            },
            async setStatus(status) {
                this.loading = true
                await axios.post(route('offers.set-status', {
                    workstation: this.form.workstation_id,
                    offerId: this.form.id,
                    status: status
                })).then(async () => {
                    await this.loadResource()
                }).finally(() => {
                    this.loading = false
                })
            },
            addProduct(index, values = {}) {
                let definition = Object.assign({
                    id: null,
                    type: null,
                    name: null,
                    product_number: null,
                    quantity: 1,
                    measurement: 'BUC',
                    unit_price: 0,
                }, values)
                if (index) {
                    this.form.products.splice(index, 0, definition);
                } else {
                    this.form.products.push(definition);
                }
            },
            deleteProduct(index) {
                if(this.form.products.length > 1) {
                    this.form.products.splice(index, 1);
                }
            },
            async downloadOffer() {
                const downloadEndpoint = new this.$db.Offer({id: this.form.id}).downloadEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            },
            async downloadDeviz() {
                const downloadEndpoint = new this.$db.Offer({id: this.form.id}).downloadDevizEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            }
        }
    };
</script>

<style lang="scss">
    .offer-tbody {
        tr {
            td {
                padding: 0 5px !important;
                .v-text-field__details {
                    display: none !important;
                    &.show {
                        display: block !important;
                    }
                }
            }
        }
    }
    .offer-thead {
        tr {
            th {
                position: sticky;
                top: 0;
            }
        }
    }
</style>
